export const loginRoute = {
  path: '/login',
};

export const redirectRoute = {
  path: '/redirect',
};

export const logoutRoute = {
  path: '/logout',
};
